import { fetchApi } from '../../db/api.js'

export function getWorkspaceDashboard(clientId, signal) {
  const query = new URLSearchParams()
  if (clientId) query.set('client_id', clientId)
  return fetchApi(`/workspace-dashboard${query.size ? `?${query}` : ''}`, { signal })
}
